const shareOnMail = (event) => {
  const el = event.currentTarget;
  const sharingUrl = el.getAttribute('data-sharing-url');
  const sharingTitle = el.getAttribute('data-sharing-title');

  const subject = encodeURIComponent(sharingTitle);
  const body = encodeURIComponent(sharingUrl);

  const mailtoLink = 'mailto:?subject=' + subject + '&body=' + body;
  window.location.href = mailtoLink;
};

const shareOnFacebook = (event) => {
  const el = event.currentTarget;
  const sharingUrl = el.getAttribute('data-sharing-url');
  const facebookShareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(sharingUrl);
  window.open(facebookShareLink, '_blank', 'width=600,height=400');
};

const shareOnTwitter = (event) => {
  const el = event.currentTarget;
  const sharingUrl = el.getAttribute('data-sharing-url');
  const sharingTitle = el.getAttribute('data-sharing-title');
  const twitterShareLink = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(sharingTitle) + '&url=' + encodeURIComponent(sharingUrl);
  window.open(twitterShareLink, '_blank', 'width=600,height=400');
};

document.addEventListener('DOMContentLoaded', () => {
  const emailLink = document.querySelector('.share__link--email');
  if (emailLink) {
    emailLink.addEventListener('click', shareOnMail);
  }

  const facebookLink = document.querySelector('.share__link--facebook');
  if (facebookLink) {
    facebookLink.addEventListener('click', shareOnFacebook);
  }

  const twitterLink = document.querySelector('.share__link--twitter');
  if (twitterLink) {
    twitterLink.addEventListener('click', shareOnTwitter);
  }
});
